/** Shared naming: dotted token path → CSS custom property name. */
const kebab = (s: string) =>
  s
    .replace(/\./g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase();

/** `'color.bg.surfaceRaised'` → `'--gg-color-bg-surface-raised'`; `'space.0.5'` → `'--gg-space-0-5'`. */
export function varName(path: string): string {
  return `--gg-${kebab(path)}`;
}

/** `cssVar('color.bg.canvas')` → `'var(--gg-color-bg-canvas)'`. For inline styles and JS-built CSS. */
export function cssVar(path: string): string {
  return `var(${varName(path)})`;
}
